.hashtag {
  appearance: none;
  border: none;
  background: none;
  font-size: inherit;
  margin: none;
  padding: none;

  &:hover {
    text-decoration: underline;
  }
}
